import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface RetentionRow {
  resource: string;
  description: string;
  defaultPolicy: string;
}

// These mirror the defaults documented in `docs/design/12-observability.md` and
// `docs/design/04-knowledge-base.md`. Configurability is on the roadmap (the
// worker would honor team-level overrides); for v1 we render the policy
// read-only with a disabled "Configure" button so the surface ships now.
const RETENTION_DEFAULTS: RetentionRow[] = [
  {
    resource: "Traces",
    description: "Per-run OTel spans + summary rows used by evals and dashboards.",
    defaultPolicy: "365 days",
  },
  {
    resource: "Knowledge base chunks",
    description: "Indexed embeddings powering Wiki + retrieval.",
    defaultPolicy: "Forever (until the parent document is deleted)",
  },
  {
    resource: "Documents",
    description: "Original uploads + parsed text + version history.",
    defaultPolicy: "Forever (soft delete on remove)",
  },
  {
    resource: "Agent messages",
    description: "User + assistant turns reconstructed from agent_requests.",
    defaultPolicy: "Forever",
  },
];

export function RetentionTab() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Retention</CardTitle>
        <CardDescription>
          Default lifetimes for each tracked resource. Per-team overrides are coming soon.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Resource</TableHead>
              <TableHead>Description</TableHead>
              <TableHead>Default policy</TableHead>
              <TableHead aria-label="actions" />
            </TableRow>
          </TableHeader>
          <TableBody>
            {RETENTION_DEFAULTS.map((row) => (
              <TableRow key={row.resource}>
                <TableCell className="font-medium">{row.resource}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{row.description}</TableCell>
                <TableCell>{row.defaultPolicy}</TableCell>
                <TableCell className="text-right">
                  <Button
                    variant="outline"
                    size="sm"
                    disabled
                    title="Configurable retention is coming soon"
                  >
                    Configure
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
